import { RootState } from "@/store/store";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";

export const budgetDetailsBudgetNameSelector = (state: RootState) => {
  return budgetDetailsByIdDataSelector(state)?.name ?? "";
};
